import React, { Component } from "react";
import history from "../login/history";
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHand } from "@fortawesome/free-solid-svg-icons";

export default class PrestamoInmediatoBanner extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        sessionStorage.setItem("saldoLinea", this.props.inmediato);
        sessionStorage.setItem("autorizador", this.props.autorizador);
    }

    prestamoInmediato = () => {
        sessionStorage.setItem("saldoLineaPi", this.props.inmediato[0].saldoLinea);
          sessionStorage.setItem("autorizador", this.props.autorizador);
        history.push("/prestamoInmediato", {});
        window.location.reload();
    }

    render() {
        return (
            <div>
                {(this.props.inmediato.length > 0 && this.props.inmediato[0].califica === 'S') && (
                    <div className="card banner-preaprobado">
                        <div className="card-body" style={{ padding: "1rem" }}>
                            <div className="row">
                                <div className="col-md-12 col-descripcion">
                                    <div className="row">

                                        <div className="col-md-9">
                                            <h5 className="texto-credito">Desembolsá tu <strong>Préstamo Digital</strong> hasta <span className="texto-banner-Pi">  {formatoSeparadorMilesValue(this.props.inmediato[0].saldoLinea)} gs</span> </h5>

                                        </div>
                                        <div className="col-md-3">
                                            <button className="btn  btn-ingresar btn-block m-auto" onClick={this.prestamoInmediato}>
                                                <FontAwesomeIcon icon={faHand} color="#EAAC24" /> Quiero
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            </div>

        );
    }
}
